(function () {
  var group = document.querySelector('[data-header-group]');
  if (!group) return;

  var lastScrollY = window.scrollY;
  var ticking = false;

  var bar = document.querySelector('[data-announcement-bar]');

  function setHeightVar() {
    document.documentElement.style.setProperty('--header-group-height', group.offsetHeight + 'px');
    document.documentElement.style.setProperty('--announcement-height', barHeight() + 'px');
  }
  window.addEventListener('resize', setHeightVar);

  function barHeight() {
    return bar ? bar.offsetHeight : 0;
  }

  /* Small dead zone so a one-pixel nudge, or the browser restoring a scroll
     position, does not flicker the fill on and off. */
  var SOLID_AT = 16;

  function onScroll() {
    var currentScrollY = window.scrollY;
    var scrollingDown = currentScrollY > lastScrollY;
    var pastOwnHeight = currentScrollY > group.offsetHeight;

    if (scrollingDown && pastOwnHeight) {
      group.classList.add('site-header-group--hidden');
    } else {
      group.classList.remove('site-header-group--hidden');
    }

    /* Transparent only at the very top; painted everywhere else. The fill is a
       CSS transition, so this just flips the class. */
    group.classList.toggle('site-header-group--solid', currentScrollY > SOLID_AT);

    /* Ride down with the announcement bar until it has scrolled away, then pin
       to the top. Clamped at 0 so over-scroll cannot push the header down. */
    group.style.setProperty('--header-offset', Math.max(0, barHeight() - currentScrollY) + 'px');

    lastScrollY = currentScrollY;
    ticking = false;
  }

  /* Run once on load: a refresh part-way down the page, or a link to an
     anchor, must not leave the bar transparent over mid-page content. */
  onScroll();

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    },
    { passive: true }
  );
})();

/* Mobile nav drawer. Uses <dialog>.showModal() so the panel lands in the top
   layer - the header group is position:fixed AND transformed, and a transformed
   ancestor would otherwise break a fixed-position drawer. Escape and focus
   trapping come free with showModal(). */
(function () {
  var dialog = document.querySelector('[data-nav-drawer]');
  if (!dialog) return;
  var toggle = document.querySelector('[data-nav-drawer-open]');

  function openDrawer() {
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer() {
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-nav-drawer-open]')) {
      event.preventDefault();
      openDrawer();
    }
  });

  dialog.addEventListener('click', function (event) {
    /* A click landing on the dialog element itself is the backdrop area. */
    if (event.target === dialog) return closeDrawer();
    if (event.target.closest('[data-nav-drawer-close]')) return closeDrawer();
    if (event.target.closest('.nav-drawer__link')) closeDrawer();
  });

  /* Fires for Escape too, so aria-expanded never goes stale. */
  dialog.addEventListener('close', function () {
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  });

  var desktop = window.matchMedia('(min-width: 45em)');
  var onChange = function (event) {
    if (event.matches && dialog.open) closeDrawer();
  };
  if (desktop.addEventListener) desktop.addEventListener('change', onChange);
  else if (desktop.addListener) desktop.addListener(onChange);
})();
